import { motion } from "framer-motion";

const timelineEvents = [
  {
    year: "1989",
    title: "A Challenging Beginning",
    description: "Born in Itang refugee camp, Ethiopia, amidst civil war and uncertainty. With a severe congenital disability affecting both legs and hips, doctors feared I might never walk. My mother's tears mixed with prayers as she held her newborn, wondering about my future.",
    image: "/lovable-uploads/2f914c44-8562-41e2-8cc5-8c1425968e78.png",
  },
  {
    year: "1991",
    title: "A Miracle of Hope",
    description: "In what can only be described as divine intervention, German aid workers discovered me crawling in the dust of the refugee camp. Despite seeing thousands of children, something about my spirit caught their attention. They promised my mother they would help - a promise that would change my life forever.",
    image: "/lovable-uploads/86ccd85f-c315-47ce-9963-abf9a3fad715.png",
  },
  {
    year: "1992",
    title: "Journey to Peace Village",
    description: "Leaving my mother's arms at age 3 was the hardest moment of both our lives. The journey to Friedensdorf in Oberhausen, Germany, was terrifying for a small child who had never left the camp. But there, I met Bettina, whose compassion would become my anchor in a strange new world.",
    image: "/lovable-uploads/af125cb6-abc4-4f47-99d4-2769126321e4.png",
  },
  {
    year: "1993-1994",
    title: "The Fight to Walk",
    description: "Through excruciating surgeries and countless rehabilitation sessions, I learned the true meaning of resilience. Every small movement was a victory, every step a miracle. The doctors who had once doubted watched in amazement as I took my first independent steps, turning medical impossibility into reality.",
    image: "/lovable-uploads/c62faa4f-c54e-473a-b3c3-a5f29534de48.png",
  },
  {
    year: "1995",
    title: "Heartbreaking Farewell",
    description: "Returning to Sudan meant leaving my second family at Peace Village. Bettina's goodbye left an ache that would last decades. But I carried with me not just the ability to walk, but a spirit transformed by love and determination.",
    image: "/lovable-uploads/faf7974f-05aa-4352-913b-a0f628999638.png",
  },
  {
    year: "2020",
    title: "A Miracle Reunion",
    description: "After 26 years of searching, a Facebook message changed everything. Bettina had never stopped looking for me. Our virtual reunion brought tears of joy to both our eyes, proving that some bonds truly transcend time and distance. A testament that miracles still happen in our modern world.",
    image: "/lovable-uploads/2f914c44-8562-41e2-8cc5-8c1425968e78.png",
  },
];

export const Timeline = () => {
  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-4xl text-story-germany mb-4">A Journey of Miracles</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Every step of this journey defied odds, every moment a testament to the power of hope and human connection
          </p>
        </motion.div>
        
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-story-hope" />
          
          {timelineEvents.map((event, index) => (
            <motion.div
              key={event.year}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className={`relative flex items-center mb-20 ${
                index % 2 === 0 ? "flex-row" : "flex-row-reverse"
              }`}
            >
              <div className="w-1/2 px-8">
                <div className={`${index % 2 === 0 ? "text-right" : "text-left"}`}>
                  <span className="text-story-hope font-bold text-xl">{event.year}</span>
                  <h3 className="text-2xl font-serif mb-2 text-story-germany">{event.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{event.description}</p>
                  
                  {/* Timeline Image */}
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className={`mt-4 ${index % 2 === 0 ? "ml-auto" : "mr-auto"} max-w-xs`}
                  >
                    <div className="relative rounded-xl overflow-hidden shadow-lg group">
                      <img
                        src={event.image}
                        alt={event.title}
                        className="w-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-story-germany/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>
                  </motion.div>
                </div>
              </div>
              <div className="absolute left-1/2 transform -translate-x-1/2 w-5 h-5 bg-story-hope rounded-full shadow-lg border-4 border-white z-10" />
              <div className="w-1/2" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};